import { useQuery } from "@apollo/client";

import {
  CampaignSortBy,
  CampaignStatus,
  ListCampaignsQuery,
  ListCampaignsQueryVariables,
} from "~frontend/__generated__/graphql";
import { LIST_CAMPAIGNS } from "~frontend/graphql/campaigns";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

type CampaignFilter = ListCampaignsQueryVariables["input"]["filter"];

// All statuses except DRAFT and ARCHIVED
const ACTIVE_CAMPAIGN_STATUS_FILTER: CampaignFilter = {
  statusIn: Object.values(CampaignStatus).filter(
    s => s !== CampaignStatus.Draft && s !== CampaignStatus.Archived
  ),
};

export function useActiveCampaigns({
  skip = false,
  limit = 50,
}: {
  skip?: boolean;
  limit?: number;
} = {}): {
  campaigns: ListCampaignsQuery["listCampaigns"]["campaigns"];
  campaignNamesById: Record<string, string>;
  loading: boolean;
  error: unknown;
} {
  const { subaccount } = useSubaccount()!;

  const { data, loading, error } = useQuery<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  >(LIST_CAMPAIGNS, {
    variables: {
      input: {
        subaccountId: subaccount.id,
        sort: CampaignSortBy.CreatedAtDesc,
        limit,
        filter: ACTIVE_CAMPAIGN_STATUS_FILTER,
      },
    },
    skip,
  });

  const campaigns = data?.listCampaigns.campaigns || [];
  const campaignNamesById = Object.fromEntries(
    campaigns.map(c => [c.id, c.name])
  );

  return { campaigns, campaignNamesById, loading, error };
}
